import axios from "axios";
import configure from "configure";

export const axiosInstance = axios.create({
    baseURL: `${configure?.nodeApi}`,
    headers: {
        "Content-Type": "application/json",
        'Access-Control-Allow-Origin': '*',
    },
});
export const axiosNodeInstance = axios.create({
    baseURL: `${configure?.nodeApi}`,
    headers: {
        "Content-Type": "application/json",
        'Access-Control-Allow-Origin': '*',
    },
});


